import AtnlSelect from "../script";

document.addEventListener( 'wpcf7invalid', ( event ) => {
	console.log('teste');
	let errorSpan = document.createElement('span',{'aria-hidden':'true'})
	errorSpan.classList.add('wpcf7-not-valid-tip')
	let errorFields = event.detail?.apiResponse?.invalid_fields
	errorFields && errorFields.forEach( info => {
		let atnlbsSelectField = document.querySelector(`${event.detail.apiResponse.into} [name="${info.field}"], ${event.detail.apiResponse.into} [name="${info.field}[]"]`).closest('.wpcf7-atnlselmulti, .wpcf7-atnlsel');
		if( !atnlbsSelectField ) return;
		let error = errorSpan.cloneNode();
		error.textContent = info.message;
		atnlbsSelectField.insertAdjacentElement('beforeend',error)
		atnlbsSelectField.classList.add('wpcf7-not-valid');
	})
}, false );

document.addEventListener('wpcf7beforesubmit', (event) => {
	let atnlbsSelectsOldErrors = document.querySelectorAll( '.wpcf7-atnlselmulti .wpcf7-not-valid-tip, .wpcf7-atnlsel .wpcf7-not-valid-tip');
	atnlbsSelectsOldErrors && atnlbsSelectsOldErrors.forEach( el => {
		el.closest('.wpcf7-atnlselmulti, .wpcf7-atnlsel').classList.remove('wpcf7-not-valid');
		el.remove();
	})
})

document.addEventListener( 'wpcf7mailsent', function( event ) {
	setTimeout(() => {
		const form = document.querySelector(`${event.detail.apiResponse.into}`);
		if( !form ) return;
		const atnlSelects = form.querySelectorAll('.atnlsel');
		if( !atnlSelects ) return;
		atnlSelects.forEach( (el) => {
			AtnlSelect.clear(el,false)
		})
	}, 1000);
}, false );

document.addEventListener( 'change', function( event ) {
	const select = event.detail?.els?.select;
	const fieldWrapper = select && select.closest('.wpcf7-atnlselmulti, .wpcf7-atnlsel');
	const fieldError = fieldWrapper && fieldWrapper.querySelector('.wpcf7-not-valid-tip');
	fieldWrapper && fieldWrapper.classList.remove('wpcf7-not-valid');
	fieldError && fieldError.remove();
})
